var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 7H21.0039C21.5562 7 22.0039 7.44771 22.0039 8V20C22.0039 20.5523 21.5562 21 21.0039 21H3.00391C2.45163 21 2.00391 20.5523 2.00391 20V4C2.00391 3.44771 2.45163 3 3.00391 3H18.0039V7ZM4.00391 9V19H20.0039V9H4.00391ZM4.00391 5V7H16.0039V5H4.00391Z",
    fill: "url(#paint0_linear_115_16001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 13H15.0039V15H18.0039V13Z",
    fill: "url(#paint1_linear_115_16001)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_16001",
    x1: 2.00391,
    y1: 12,
    x2: 22.0039,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_16001",
    x1: 15.0039,
    y1: 14,
    x2: 18.0039,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8ec099a11c1e4e798ec6d41663e6f9a7.svg";
export { ForwardRef as ReactComponent };